// extracted by mini-css-extract-plugin
export default {"icon":"go-back_icon__uPBno","title":"go-back_title__IS3rq"};